export type FaqEntry = {
  questionKey: string
  answerKey: string
}

export const HELP_FAQ_ITEMS: FaqEntry[] = [
  { questionKey: 'faq.hotspot.question', answerKey: 'faq.hotspot.answer' },
  { questionKey: 'faq.wallet.question', answerKey: 'faq.wallet.answer' },
  { questionKey: 'faq.payouts.question', answerKey: 'faq.payouts.answer' },
  { questionKey: 'faq.subscription.question', answerKey: 'faq.subscription.answer' },
  { questionKey: 'faq.privacy.question', answerKey: 'faq.privacy.answer' },
  { questionKey: 'faq.accountDeletion.question', answerKey: 'faq.accountDeletion.answer' },
  { questionKey: 'faq.apiTokens.question', answerKey: 'faq.apiTokens.answer' },
  { questionKey: 'faq.webhooks.question', answerKey: 'faq.webhooks.answer' },
]
